import React from 'react'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import { Testimony } from '@quotatisgroup/uikit-public.ui.testimony'
import cloudinary from 'utils/cloudinary'
import PropTypes from 'prop-types'
import uuid from 'uuid/v4'

const OurProBlock = ({ title, pros }) => (
  <Row padding="md" mdPadding="vertical-lg">
    <Col md="12" align="center" mdMargin="bottom-md">
      <Title headingLevel="2">{title}</Title>
    </Col>
    {pros.map(({ href, name, job, city, testimony, image }) => (
      <Col key={uuid()} sm="12" md="4" padding="top-md" mdPadding="right-sm">
        <Testimony
          href={href}
          img={cloudinary(`/vitrine/image/${image}.png`)}
          name={name}
          job={job}
          city={city}
          testimony={testimony}
        />
      </Col>
    ))}
  </Row>
)

OurProBlock.propTypes = {
  title: PropTypes.string,
  pros: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      job: PropTypes.string.isRequired,
      testimony: PropTypes.string.isRequired,
    }),
  ),
}

export default OurProBlock
